var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#40464D",
    strokeWidth: 2,
    d: "M15,7 C15.275,7 15.5243631,7.11357666 15.7053932,7.29460678 C15.8864233,7.4756369 16,7.725 16,8 L16,16 C16,16.275 15.8864233,16.5243631 15.7053932,16.7053932 C15.5243631,16.8864233 15.275,17 15,17 L3,17 C2.725,17 2.4756369,16.8864233 2.29460678,16.7053932 C2.11357666,16.5243631 2,16.275 2,16 L2,8 C2,7.725 2.11357666,7.4756369 2.29460678,7.29460678 C2.4756369,7.11357666 2.725,7 3,7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40464D",
    fillRule: "nonzero",
    d: "M9,18 C7.87475819,18 6.83633255,17.6282958 6.00081101,17.0009752 L11.999189,17.0009752 C11.1636674,17.6282958 10.1252418,18 9,18 Z M9,0 C11.7614237,0 14,2.23857625 14,5 L14,7 L12,7 L12,5 C12,3.34314575 10.6568542,2 9,2 C7.34314575,2 6,3.34314575 6,5 L6,7 L4,7 L4,5 C4,2.23857625 6.23857625,0 9,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40464D",
    d: "M9,10 C9.55228475,10 10,10.4477153 10,11 L10,13 C10,13.5522847 9.55228475,14 9,14 C8.44771525,14 8,13.5522847 8,13 L8,11 C8,10.4477153 8.44771525,10 9,10 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.f5068d845007e89b4aec28d724117d25.svg";
export { ForwardRef as ReactComponent };